
namespace RioERP.Carts {
    export class FranchiseeProductsColumns {
        static columnsKey = 'Carts.FranchiseeProducts';
    }
}